import request from "@/utils/request";
// 上传附件
export function isupload(data) {
  return request({
    url: "/resources/upload",
    method: "post",
    data,
  });
}

// 上传附件接口
export function uploadFile(data) {
  return request({
    url: "/form/resource",
    method: "post",
    data,
  });
}
// 获取字典
export function selectSysDic(chooseType) {
  return request({
    url: `/admin/choose/${chooseType}`,
    method: "get",
  });
}

// 获取字典
export function selectRankingDic(chooseType, workId) {
  return request({
    url: `/admin/select/${chooseType}/${workId}`,
    method: "get",
  });
}

// 获取省份
export function getCityProvice(params) {
  return request({
    url: "/sysArea/citylist",
    method: "get",
    params,
  });
}

export function getCityProviceList(params) {
  return request({
    url: "/sysArea/selectCitys",
    method: "get",
    params,
  });
}

// 根据id获取附件信息

export function getFileById(data) {
  return request({
    url: "/form/resource/get",
    method: "post",
    data,
  });
}
// 通用下载接口

export function downloadFile(data) {
  return request({
    url: "/form/resource/down",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 通用下载接口

export function download2zip(params) {
  return request({
    url: "/file/download2zip",
    method: "get",
    params,
    responseType: "blob",
  });
}

// 获取验证码接口
export function getCode(data) {
  return request({
    url: "/sys/user/get",
    method: "post",
    data,
  });
}
// 核对验证码接口
export function checkCode(data) {
  return request({
    url: "/sys/user/check",
    method: "post",
    data,
  });
}

// 导出附件以及提交时候的校验接口
export function getSubmitLog(data) {
  return request({
    url: `/submit/log/getSubmitLog`,
    method: "post",
    data,
  });
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: "/user/reset/pwd",
    method: "post",
    data,
  });
}

